import tinymce from 'tinymce/tinymce'

// Theme + icons (required for the default UI)
import 'tinymce/models/dom'
import 'tinymce/themes/silver'
import 'tinymce/icons/default'

// Minimal plugins (add/remove as needed)
import 'tinymce/plugins/lists'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code' // optional but useful for debugging

import 'tinymce/skins/ui/oxide/skin.min.css'

function initTinyMCE() {
  // Avoid double-init when navigating with Turbo/Turbolinks
  const selector = 'textarea.js-tinymce'
  if (!document.querySelector(selector)) return

  tinymce.init({
    selector: 'textarea.js-tinymce',

    /*
    skin: false,
    content_css: false,
    */

    base_url: '/packs/tinymce',
    suffix: '.min',

    menubar: false,

    plugins: [
      'lists',
      'link',
      'code'
    ],

    toolbar: [
      'blocks | bold italic underline | forecolor | bullist numlist | link | removeformat'
    ],

    branding: false,
    promotion: false
  })
}

document.addEventListener('DOMContentLoaded', initTinyMCE)
